import React from 'react';
import { Spinner as BootstrapSpinner } from 'react-bootstrap';
import './Spinner.css';

/**
 * Reusable spinner component for loading states
 * @param {Object} props - Component props
 * @param {boolean} props.small - Whether to display a smaller spinner
 */
const Spinner = ({ small }) => {
  return (
    <BootstrapSpinner
      animation="border"
      role="status"
      size={small ? "sm" : undefined}
      className={small ? "spinner-small" : "spinner-standard"}
    >
      <span className="visually-hidden">Loading...</span>
    </BootstrapSpinner>
  );
};

export default Spinner;
